import { eventsConstants } from '../constants'

// list: null finché la richiesta è in corso; error: l'API non ha risposto
const initialState = {
  list: null,
  error: false
}

export default function events(state = initialState, action) {
  switch (action.type) {
    case eventsConstants.EVENTS_LOADED:
      return { list: action.payload, error: false }
    case eventsConstants.EVENTS_FAILED:
      return { list: [], error: true }
    default:
      return state
  }
}
